export const EVENTS_QUERY_KEY = "events";
export const RSVPS_QUERY_KEY = "rsvps";
export const EVENT_GALLERY_QUERY_KEY = "eventGallery";
